




































































import { EventResponse } from '@/model/Event';
import { Component, Prop, Vue } from 'vue-property-decorator';
import ToggleableText from '@/components/form/ToggleableText.vue';
import EventIcon from './EventIcon.vue';

@Component({
    components: {
        ToggleableText,
        EventIcon,
    },
})
export default class EventHeader extends Vue {
    @Prop() readonly event!: EventResponse | null;

    windowInnerWidth = window.innerWidth;

    onClick(): void {
        this.$router.push(`/event/${this.event?.id}/editors`);
    }

    mounted(): void {
        window.addEventListener('resize', this.onResize);
    }

    beforeDestroy(): void {
        window.removeEventListener('resize', this.onResize);
    }

    onResize(): void {
        this.windowInnerWidth = window.innerWidth;
    }
}
